import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './ui-filter-item.css?inline';

const CName = 'ui-filter-item';

@customElement(CName)
export class UIFilterItem extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: Boolean }) active = false;
  @property({ type: Boolean }) useButton = false;
  @property({ type: String }) class = '';
  @property({ type: String }) label = '';

  render() {
    let className = `filter-item ${this.class}`;
    if (this.active === true) {
      className = `active ${className}`;
    }
    return html`
      ${
        this.useButton
          ? html`<button class=${className}>${this.label}</button>`
          : html`<span class=${className} tabindex="0">${this.label}</span>`
      }
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIFilterItem;
  }
}
